module.exports = __webpack_public_path__ + "static/logo-a8664ae9e3d25ed6248e7b436b48b618.png";